export default class DirectLogoUploadSaver {
  static save(cropper, uploadedFile, application) {
    const brandElement = document.querySelector(
      "[data-controller='site-builder--brand']"
    );
    if (brandElement) {
      const brandController = application.getControllerForElementAndIdentifier(
        brandElement,
        "site-builder--brand"
      );
      if (brandController) {
        const hasCropped = cropper?.hasChanged?.() ?? false;

        const persistedName = document
          .querySelector('.logo-cropper-details')
          ?.getAttribute('data-original-image-name');
        const filename = uploadedFile?.name || persistedName || 'logo.png';

        if (!hasCropped) {
          if (uploadedFile) {
            this.setLogoBlobAndUpdate(brandController, uploadedFile, filename);
          }
          return;
        }

        const canvas = cropper.get_cropped_canvas();
        const mimeType = cropper.get_image_mime_type();

        canvas.toBlob((blob) => {
          this.setLogoBlobAndUpdate(brandController, blob, filename);
        }, mimeType);
      } else {
        console.error("BrandController instance not found");
      }
    } else {
      console.error(
        "Element with 'data-controller=site-builder--brand' not found"
      );
    }
  }

  static setLogoBlobAndUpdate(brandController, blob, name) {
    const url = URL.createObjectURL(blob);
    window.blobs = { ...window.blobs, logo: blob };
    brandController.updateLogo({ url, name });
  }
}
